import { render, staticRenderFns } from "./order-row.vue?vue&type=template&id=3465f2df&scoped=true&"
import script from "./order-row.vue?vue&type=script&lang=js&"
export * from "./order-row.vue?vue&type=script&lang=js&"
import style0 from "./order-row.vue?vue&type=style&index=0&id=3465f2df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465f2df",
  null
  
)

export default component.exports